import { render, staticRenderFns } from "./QuizHeader.vue?vue&type=template&id=a2477afc"
import script from "./QuizHeader.vue?vue&type=script&lang=js"
export * from "./QuizHeader.vue?vue&type=script&lang=js"
import style0 from "./QuizHeader.vue?vue&type=style&index=0&id=a2477afc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports